export default function IlustrationUploadedPassword() {
  return (
    <svg
      fill="none"
      height="120"
      viewBox="0 0 152 120"
      width="152"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="76" cy="52" fill="#D9D6FE" r="52" />
      <g filter="url(#filter0_dd_14848_1877)">
        <path
          d="M77.5996 16C90.7795 16 102.096 23.9689 107 35.3506C107.853 35.252 108.72 35.2002 109.6 35.2002C121.971 35.2002 132 45.2286 132 57.5996C132 69.7776 122.282 79.6857 110.178 79.9922L109.6 80H45.5996C31.4614 79.9998 20.0002 68.5386 20 54.4004C20 40.262 31.4613 28.8 45.5996 28.7998C47.6295 28.7998 49.6045 29.0369 51.498 29.4834C57.2971 21.3235 66.8267 16.0001 77.5996 16Z"
          fill="#F4F3FF"
        />
        <ellipse
          cx="45.6"
          cy="54.3998"
          fill="url(#paint0_linear_14848_1877)"
          rx="25.6"
          ry="25.6"
        />
        <circle
          cx="77.5996"
          cy="48"
          fill="url(#paint1_linear_14848_1877)"
          r="32"
        />
        <ellipse
          cx="109.6"
          cy="57.6002"
          fill="url(#paint2_linear_14848_1877)"
          rx="22.4"
          ry="22.4"
        />
      </g>
      <circle cx="21" cy="19" fill="#EBE9FE" r="5" />
      <circle cx="18" cy="109" fill="#EBE9FE" r="7" />
      <circle cx="145" cy="35" fill="#EBE9FE" r="7" />
      <circle cx="134" cy="8" fill="#EBE9FE" r="4" />
      <foreignObject height="64" width="64" x="44" y="54">
        <div style={{ backdropFilter: "blur(4px)" }}>
          <svg>
            <defs>
              <clipPath id="bgblur_0_14848_1877_clip_path">
                <path d="M52 86C52 72.7452 62.7452 62 76 62C89.2548 62 100 72.7452 100 86C100 99.2548 89.2548 110 76 110C62.7452 110 52 99.2548 52 86Z" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </foreignObject>
      <g data-figma-bg-blur-radius="8">
        <path
          d="M52 86C52 72.7452 62.7452 62 76 62C89.2548 62 100 72.7452 100 86C100 99.2548 89.2548 110 76 110C62.7452 110 52 99.2548 52 86Z"
          fill="#6941C6"
          fillOpacity="0.4"
        />
        <path
          d="M86 85.0857V86.0057C85.9988 88.1621 85.3005 90.2604 84.0093 91.9875C82.7182 93.7147 80.9033 94.9782 78.8354 95.5896C76.7674 96.201 74.5573 96.1276 72.5345 95.3803C70.5117 94.633 68.7847 93.2518 67.611 91.4428C66.4373 89.6338 65.8798 87.4938 66.0217 85.342C66.1636 83.1903 66.9972 81.1421 68.3983 79.5028C69.7994 77.8635 71.6928 76.7211 73.7962 76.2459C75.8996 75.7706 78.1003 75.9881 80.07 76.8657M86 78L76 88.01L73 85.01"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="104"
          id="filter0_dd_14848_1877"
          width="152"
          x="0"
          y="16"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect1_dropShadow_14848_1877"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_14848_1877"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="erode"
            radius="4"
            result="effect2_dropShadow_14848_1877"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            in2="effect1_dropShadow_14848_1877"
            mode="normal"
            result="effect2_dropShadow_14848_1877"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_14848_1877"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_14848_1877"
          x1="25.9429"
          x2="71.2"
          y1="37.4855"
          y2="79.9998"
        >
          <stop stopColor="#E9D7FE" />
          <stop offset="0.350715" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_14848_1877"
          x1="53.0282"
          x2="109.6"
          y1="26.8571"
          y2="80"
        >
          <stop stopColor="#E9D7FE" />
          <stop offset="0.350715" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_14848_1877"
          x1="92.4002"
          x2="132"
          y1="42.8002"
          y2="80.0002"
        >
          <stop stopColor="#E9D7FE" />
          <stop offset="0.350715" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
